import {Component, ViewChild} from "@angular/core";
import {ContactEntityModel} from "../../contact-entity.model";
import {ContactAccountPinData} from "../../contact.data";
import {AccountSearchPageComponent} from "../../../accounts/account/account-search-page/account-search-page.component";
import {AccountEditPageComponent} from "../../../accounts/account/account-edit-page/account-edit-page.component";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {AccountData, AccountPinData} from "../../../accounts/account/account.data";
import {EntityData} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-contact-edit-accounts",
    templateUrl: "./contact-edit-accounts.component.html"
})
export class ContactEditAccountsComponent {

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    AccountSearchPageComponent = AccountSearchPageComponent;
    AccountEditPageComponent = AccountEditPageComponent;
    EditMode = EditMode;

    constructor(public model: ContactEntityModel, public editService: EditService) {
    }

    addAccountFromSearch(accounts: any[]) {
        let firstRow: boolean = true;
        accounts.forEach((account: any) => {
            const accountPinData: ContactAccountPinData = <ContactAccountPinData>EntityData.create(ContactAccountPinData);
            accountPinData.account = account;
            accountPinData.defaultContact = false;
            if (firstRow) {
                this.editGridComponent.addAndEditRow(accountPinData);
            } else {
                this.editGridComponent.addRow(accountPinData);
            }
            firstRow = false;
        });
    }

    addAccountFromNew(account: AccountData) {
        const accountPinData: ContactAccountPinData = <ContactAccountPinData>EntityData.create(ContactAccountPinData);
        accountPinData.account = account; // partial assign
        account.collectionLoaded.subscribe((
            loaded: {
                path: string,
                collection: EntityData<any>[]
            }
        ) => {
            if (loaded.path === "accountPins") {
                const findAccountPinOnAccount: any = account.accountPins.find((pin) => pin.contact.id === this.model.data.id);
                if (findAccountPinOnAccount) {
                    accountPinData.accountPinId = findAccountPinOnAccount.accountPinId;
                    accountPinData.version = findAccountPinOnAccount.version;
                    accountPinData.pin = findAccountPinOnAccount.pin;
                    accountPinData.defaultContact = findAccountPinOnAccount.defaultContact;
                    this.editGridComponent.addRow(accountPinData);
                }
            }
        });

        const forceLoad: AccountPinData[] = account.accountPins;
    }

    rowRemovable(rowIndex: number, accountPin: AccountPinData): boolean {
        return !(accountPin.defaultContact || accountPin.invoiceContact || accountPin.statementContact);
    }
}
